import React from 'react';
import PropTypes from 'prop-types';

import './SevenSegment.scss';

/* eslint-disable */
const SEGMENTS = {
  A: [ true, false,  true,  true, false,  true,  true,  true,  true,  true, false, false],
  B: [ true,  true,  true,  true,  true, false, false,  true,  true,  true, false, false],
  C: [ true,  true, false,  true,  true,  true,  true,  true,  true,  true, false, false],
  D: [ true, false,  true,  true, false,  true,  true, false,  true,  true, false, false],
  E: [ true, false,  true, false, false, false,  true, false,  true, false, false, false],
  F: [ true, false, false, false,  true,  true,  true, false,  true,  true, false, false],
  G: [false, false,  true,  true,  true,  true,  true, false,  true,  true, true, false],
};
/* eslint-enable */

const SevenSegment = (props) => {

  const {
    digits,
    color,
    opacityOn,
    opacityOff,
    scale,
    translateX,
    translateY,
  } = props;

  const isDigitHyphenOrSpace = (e) => ('0123456789- '.indexOf(e) >= 0);
  const characterIndex = (e) => ('0123456789- '.indexOf(e));

  const widths = [...digits].map((e) => (isDigitHyphenOrSpace(e) ? 22 : 11));
  const totalWidth = widths.reduce((acc, e) => acc + e, 0);
  let acc = 4;
  const offsets = widths.map((e) => {
    const oldAcc = acc;
    acc += e;
    return oldAcc;
  });

  const height = 40;

  const transform = `translate(${translateX}, ${translateY}) scale(${scale})`;

  return (
    <svg
      className="seven-segment"
      width={totalWidth + 5}
      height={height}
      preserveAspectRatio="xMidYMid"
      transform={transform}
    >
      {
        [...digits].map((digit, i) => (
          <g
            stroke={color}
            fill={color}
            strokeWidth="0.2"
            transform={`translate(${offsets[i]}, 0) skewX(-8)`}
          >

            {/* eslint-disable-next-line no-nested-ternary */}
            {isDigitHyphenOrSpace(digit) ? (
              <>
                <polygon
                  className="A"
                  points=" 5, 4  7, 6 15, 6 17, 4 15, 2  7, 2"
                  opacity={SEGMENTS.A[characterIndex(digit)] ? opacityOn : opacityOff}
                />
                <polygon
                  className="B"
                  points="18, 5 16, 7 16,15 18,17 20,15 20, 7"
                  opacity={SEGMENTS.B[characterIndex(digit)] ? opacityOn : opacityOff}
                />
                <polygon
                  className="C"
                  points="18,19 16,21 16,29 18,31 20,29 20,21"
                  opacity={SEGMENTS.C[characterIndex(digit)] ? opacityOn : opacityOff}
                />
                <polygon
                  className="D"
                  points=" 5,32 7,34 15,34 17,32 15,30  7,30"
                  opacity={SEGMENTS.D[characterIndex(digit)] ? opacityOn : opacityOff}
                />
                <polygon
                  className="E"
                  points=" 4,19  2,21  2,29  4,31  6,29  6,21"
                  opacity={SEGMENTS.E[characterIndex(digit)] ? opacityOn : opacityOff}
                />
                <polygon
                  className="F"
                  points=" 4, 5  2, 7  2,15  4,17  6,15  6, 7"
                  opacity={SEGMENTS.F[characterIndex(digit)] ? opacityOn : opacityOff}
                />
                <polygon
                  className="G"
                  points=" 5,18  7,20 15,20 17,18 15,16  7,16"
                  opacity={SEGMENTS.G[characterIndex(digit)] ? opacityOn : opacityOff}
                />
              </>
            ) : (digit === ':'
              ? (
                <>
                  <polygon
                    points="4, 8  4, 12  8, 12  8, 8"
                    opacity={opacityOn}
                  />
                  <polygon
                    points="4, 23  4, 27  8, 27  8, 23"
                    opacity={opacityOn}
                  />
                </>
              ) : <div />
            )}
          </g>
        ))
      }
    </svg>
  );
};

SevenSegment.propTypes = ({
  digits: PropTypes.string.isRequired,
  color: PropTypes.string,
  opacityOn: PropTypes.number,
  opacityOff: PropTypes.number,
  scale: PropTypes.number,
  translateX: PropTypes.number,
  translateY: PropTypes.number,
});

SevenSegment.defaultProps = {
  color: '#0F0',
  opacityOn: 1.0,
  opacityOff: 0.1,
  scale: 1.0,
  translateX: 0,
  translateY: 0,
};

export default SevenSegment;
